import { createRouter, createWebHistory, RouterView } from 'vue-router'
import { h } from 'vue'
import { Auth0Guard } from "@/auth/Auth0";
import * as qs from "qs";
import store from "@/store";
import { getAvailableDivisionId } from "@/lib/Divisions";


const proxyComponent = { render: () => h(RouterView) }
const routes = [
  {
    path: '/care-assignments',
    name: 'care-assignments',
    component: () => import('@/views/patient_monitors/PatientMonitorsAssignments.vue'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/my-assignments',
    name: 'my-assignments',
    component: () => import('@/views/MyAssignments'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/h/:orgId',
    component: () => import('@/views/HospitalRedirect'),
    name: 'hospital-redirect',
    meta: {
      unsecured: true,
      layout: 'blank'
    }
  },
  {
    path: '/helpscout-auth',
    name: 'helpscout-auth',
    component: () => import('@/views/HelpScoutAuth'),
    meta: {
      layout: 'blank'
    }
  },
  {
    path: '/password-changed',
    component: () => import('@/views/PasswordChanged'),
    name: 'password-changed',
    meta: {
      unsecured: true,
      layout: 'blank',
      withoutDivision: true
    }
  },
  {
    path: '/fhir-launch',
    name: 'fhir-launch',
    component: () => import('@/views/FhirLaunch'),
    meta: {
      unsecured: true,
      layout: 'blank',
      withoutDivision: true
    }
  },
  {
    path: '/fhir',
    name: 'fhir',
    component: () => import('@/views/Fhir'),
    meta: {
      unsecured: true,
      layout: 'blank'
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/Home'),
    meta: {
      allDivisionsEnabled: false
    }
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('@/views/About.vue'),
  },
  {
    path: '/patients',
    component: proxyComponent,
    children: [
      {
        path: '',
        name: 'patients.index',
        component: () => import('@/views/patient/PatientList'),
      },
      {
        path: 'add',
        name: 'patients.add',
        component: () => import('@/views/patient/AddPatient'),
      },
      {
        path: ':id/edit',
        name: 'patients.edit',
        component: () => import('@/views/patient/AddPatient'),
      },
      {
        path: ':id/view',
        name: 'patients.view',
        component: () => import('@/views/patient/ViewPatient')
      },
      {
        path: ':id/overview',
        component: () => import('@/views/patient/overview/OverviewLayout'),
        children: [
          {
            path: 'edit',
            name: 'patients.overview.edit',
            component: () => import('@/views/patient/overview/OverviewEdit'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'monitors',
            name: 'patients.overview.monitors',
            component: () => import('@/views/patient/overview/OverviewMonitors'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'forms',
            name: 'patients.overview.forms',
            component: () => import('@/views/patient/overview/OverviewForms'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'video-visit',
            name: 'patients.overview.video-visit',
            component: () => import('@/views/patient/overview/OverviewVideoVisits'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'ai-insights',
            name: 'patients.overview.ai-insights',
            component: () => import('@/views/patient/overview/OverviewAiInsights.vue'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'time-machine',
            name: 'patients.overview.timeline',
            component: () => import('@/views/patient/overview/OverviewTimeMachine.vue'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'video-summaries',
            name: 'patients.overview.video-summaries',
            component: () => import('@/views/patient/overview/OverviewVideoSummaries.vue'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/patient-monitors',
    component: proxyComponent,
    children: [
      {
        path: '',
        name: 'patient-monitors.index',
        component: () => import('@/views/patient_monitors/PatientMonitorsList')
      },
      {
        path: 'multipause',
        name: 'patient-monitors.multipause',
        component: () => import('@/views/patient_monitors/MultiPause'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'multiresume',
        name: 'patient-monitors.multiresume',
        component: () => import('@/views/patient_monitors/MultiResume'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: '/patient-monitors/add',
        name: 'patient-monitors.add',
        component: () => import('@/views/patient_monitors/AddMonitor'),
        meta: {
          allDivisionsEnabled: false
        }
      },
      {
        path: '/patient-monitors/:id/edit',
        name: 'patient-monitors.edit',
        component: () => import('@/views/patient_monitors/AddMonitor'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: '/patient-monitors/:id/monitoring',
        name: 'patient-monitors.monitoring',
        component: () => import('@/views/patient_monitors/Monitoring'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: '/patient-monitors/:id/view',
        name: 'patient-monitors.view',
        component: () => import('@/views/patient_monitors/Overview'),
        meta: {
          withoutDivision: true
        }
      },
    ]
  },
  {
    path: '/health-system',
    component: proxyComponent,
    children: [
      {
        path: 'page_preferences',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.page_preferences.index',
            component: () => import('@/views/hsl/page_preferences/PagePreferences'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'hsl.page_preferences.add',
            component: () => import('@/views/hsl/page_preferences/AddEditPagePreference'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.page_preferences.edit',
            component: () => import('@/views/hsl/page_preferences/AddEditPagePreference'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'staff-types',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.staff-types.index',
            component: () => import('@/views/staff_types/StaffTypes.vue'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.staff-types.edit',
            component: () => import('@/views/staff_types/EditStaffType.vue'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'adt-rules',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.adt-rules.index',
            component: () => import('@/views/hsl/adt_rules/AdtRulesIndex'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'hsl.adt-rules.add',
            component: () => import('@/views/hsl/adt_rules/EditAdtRule'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.adt-rules.edit',
            component: () => import('@/views/hsl/adt_rules/EditAdtRule'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'aimee-prompts',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.aimee-prompts.index',
            component: () => import('@/views/aimee/Prompts.vue'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'hsl.aimee-prompts.add',
            component: () => import('@/views/aimee/AddPrompt.vue'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.aimee-prompts.edit',
            component: () => import('@/views/aimee/AddPrompt.vue'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'custom-fields',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.custom-fields.index',
            component: () => import('@/views/hsl/custom_fields/CustomFields'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: 'add',
            name: 'hsl.custom-fields.add',
            component: () => import('@/views/hsl/custom_fields/EditCustomField'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: ':id/edit',
            name: 'hsl.custom-fields.edit',
            component: () => import('@/views/hsl/custom_fields/EditCustomField'),
            meta: {
              withoutDivision: true
            },
          }
        ]
      },
      {
        path: 'tags',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.tags',
            component: () => import('@/views/hsl/tags/TagsIndex'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: 'add',
            name: 'hsl.tags.add',
            component: () => import('@/views/hsl/tags/AddTags'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.tags.edit',
            component: () => import('@/views/hsl/tags/AddTags'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'video-reasons',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.video-reasons.index',
            component: () => import('@/views/hsl/video_reasons/VideoReasonsIndex'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: 'add',
            name: 'hsl.video-reasons.add',
            component: () => import('@/views/hsl/video_reasons/AddVideoReason'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.video-reasons.edit',
            component: () => import('@/views/hsl/video_reasons/AddVideoReason'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'recording-rules',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.recording-rules.index',
            component: () => import('@/views/hsl/recording_rules/RecordingRulesIndex'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: 'add',
            name: 'hsl.recording-rules.add',
            component: () => import('@/views/hsl/recording_rules/AddEditRecordingRule'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.recording-rules.edit',
            component: () => import('@/views/hsl/recording_rules/AddEditRecordingRule'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'manage-views',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.manage-views',
            component: () => import('@/views/hsl/manage_views/ManageViews'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.manage-views.edit',
            component: () => import('@/views/hsl/manage_views/EditSharedView'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'hospitals',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.hospitals.index',
            component: () => import('@/views/hsl/hospitals/HospitalsIndex'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'hsl.hospitals.add',
            component: () => import('@/views/hsl/hospitals/ManageHospital'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.hospitals.edit',
            component: () => import('@/views/hsl/hospitals/ManageHospital'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'preferences',
        name: 'hsl.preferences',
        component: () => import('@/views/hsl/preferences'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'dynamic-fields',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.dynamic-fields.index',
            component: () => import('@/views/hsl/dynamic_fields/DynamicFields'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: ':id/edit',
            name: 'hsl.dynamic-fields.edit',
            component: () => import('@/views/hsl/dynamic_fields/EditDynamicFieldValues'),
            meta: {
              withoutDivision: true
            },
          }
        ]
      },
      {
        path: 'column-transformers',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hsl.column-transformers.index',
            component: () => import('@/views/hsl/column_transformers/ColumnTransformers'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'hsl.column-transformers.add',
            component: () => import('@/views/hsl/column_transformers/EditColumnTransformer'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'hsl.column-transformers.edit',
            component: () => import('@/views/hsl/column_transformers/EditColumnTransformer'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/hospital',
    component: proxyComponent,
    children: [
      {
        path: 'preferences',
        name: 'hospital.preferences',
        component: () => import('@/views/hospital/DivisionPreferences'),
        meta: {
          allDivisionsEnabled: false
        }
      },
      {
        path: 'rooms',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hospital.rooms',
            component: () => import('@/views/hospital/rooms/Rooms'),
          },
          {
            path: 'add',
            name: 'hospital.rooms.add',
            component: () => import('@/views/hospital/rooms/AddRoom'),
            meta: {
              allDivisionsEnabled: false
            }
          },
          {
            path: ':id/edit',
            name: 'hospital.rooms.edit',
            component: () => import('@/views/hospital/rooms/AddRoom'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'units',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hospital.units',
            component: () => import('@/views/hospital/units/Units'),
          },
          {
            path: 'add',
            name: 'hospital.units.add',
            component: () => import('@/views/hospital/units/AddUnit'),
          },
          {
            path: ':id/edit',
            name: 'hospital.units.edit',
            component: () => import('@/views/hospital/units/AddUnit'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/view',
            name: 'hospital.units.view',
            component: () => import('@/views/hospital/units/ViewUnit'),
          },
        ]
      },
      {
        path: 'video_devices',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'hospital.video_devices',
            component: () => import('@/views/hospital/video_devices/VideoDevices'),
          },
          {
            path: 'add',
            name: 'hospital.video_devices.add',
            component: () => import('@/views/hospital/video_devices/AddVideoDevice'),
          },
          {
            path: ':id/edit',
            name: 'hospital.video_devices.edit',
            component: () => import('@/views/hospital/video_devices/AddVideoDevice'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/view',
            name: 'hospital.video_devices.view',
            component: () => import('@/views/hospital/video_devices/ViewVideoDevice'),
          }
        ]
      },
      {
        path: 'homepage',
        name: 'hospital.homepage',
        component: () => import('@/views/hospital/HomepageSettings'),
        meta: {
          allDivisionsEnabled: false
        }
      },
    ]
  },
  {
    path: '/user-management',
    component: proxyComponent,
    children: [
      {
        path: 'users',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'user-management.users',
            component: () => import('@/views/user_management/users/Users'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'user-management.users.edit',
            component: () => import('@/views/user_management/users/AddEditUser'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'user-management.users.add',
            component: () => import('@/views/user_management/users/AddEditUser'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'roles',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'user-management.roles',
            component: () => import('@/views/user_management/roles/Roles'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'user-management.roles.add',
            component: () => import('@/views/user_management/roles/AddRole'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'user-management.roles.edit',
            component: () => import('@/views/user_management/roles/AddRole'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/view',
            name: 'user-management.roles.view',
            component: () => import('@/views/user_management/roles/ViewRole'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'groups',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'user-management.groups',
            component: () => import('@/views/user_management/groups/Groups'),
            meta: {
              withoutDivision: true
            },
          },
          {
            path: 'add',
            name: 'user-management.groups.add',
            component: () => import('@/views/user_management/groups/AddGroup'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'user-management.groups.edit',
            component: () => import('@/views/user_management/groups/AddGroup'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/view',
            name: 'user-management.groups.view',
            component: () => import('@/views/user_management/groups/ViewGroup'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'access-browser',
        name: 'user-management.access-browser',
        component: () => import('@/views/user_management/AccessBrowser'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'family-connect',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'user-management.family-connect',
            component: () => import('@/views/user_management/family_connect/FamilyConnectList'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'user-management.family-connect.add',
            component: () => import('@/views/user_management/family_connect/FamilyConnectAdd'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'user-management.family-connect.edit',
            component: () => import('@/views/user_management/family_connect/FamilyConnectAdd'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'labelers',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'user-management.labelersindex',
            component: () => import('@/views/user_management/labelers/Labelers'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'user-management.labelersadd',
            component: () => import('@/views/user_management/labelers/AddLabeler'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'user-management.labelersedit',
            component: () => import('@/views/user_management/labelers/AddLabeler'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
    ]
  },
  {
    path: '/monitoring',
    component: proxyComponent,
    children: [
      {
        path: 'inbound-requests',
        name: 'monitoring.inbound-requests',
        component: () => import('@/views/monitoring/InboundRequests'),
      },
      {
        path: 'logs',
        name: 'monitoring.logs',
        component: () => import('@/views/monitoring/Logs'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'monitor-connections',
        name: 'monitoring.monitor-connections',
        component: () => import('@/views/monitoring/MonitorConnections'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'system-overview',
        name: 'monitoring.system-overview',
        component: () => import('@/views/monitoring/SystemOverview'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'devices-uptime',
        name: 'monitoring.devices-uptime',
        component: () => import('@/views/monitoring/DeviceUptime'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'adt-messages',
        name: 'monitoring.adt-messages',
        component: () => import('@/views/monitoring/AdtMessages'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'nurse-call',
        name: 'monitoring.nurse-call',
        component: () => import('@/views/monitoring/NurseCall'),
        meta: {
          withoutDivision: true
        }
      },
    ]
  },
  {
    path: '/system',
    component: proxyComponent,
    children: [
      {
        path: 'partners',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'system.partners',
            component: () => import('@/views/system/partners/PartnersIndex'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'add',
            name: 'system.partners.add',
            component: () => import('@/views/system/partners/AddPartner'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'system.partners.edit',
            component: () => import('@/views/system/partners/AddPartner'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: 'api-docs',
            name: 'system.partners.api-docs',
            component: () => import('@/views/system/partners/ApiDocs'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      },
      {
        path: 'background-jobs',
        name: 'system.background-jobs',
        component: () => import('@/views/system/BackgroundJobs'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: 'feature-flags',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'system.feature-flags',
            component: () => import('@/views/user_management/feature_flags/FeatureFlags'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/edit',
            name: 'system.feature-flags.edit',
            component: () => import('@/views/user_management/feature_flags/ManageFeatureFlags'),
            meta: {
              withoutDivision: true
            }
          },
        ]
      },
      {
        path: 'test-adt',
        name: 'system.test-adt',
        component: () => import('@/views/system/TestAdt'),
      },
      {
        path: 'test-nurse-call',
        name: 'system.test-nurse-call',
        component: () => import('@/views/system/TestNurseCall'),
      },
      {
        path: 'aimee-conversations',
        component: proxyComponent,
        children: [
          {
            path: '',
            name: 'system.aimee-conversations',
            component: () => import('@/views/system/AimeeConversations'),
            meta: {
              withoutDivision: true
            }
          },
          {
            path: ':id/view',
            name: 'system.aimee-conversations.view',
            component: () => import('@/views/system/ViewAimeeConversation'),
            meta: {
              withoutDivision: true
            }
          }
        ]
      }
    ]
  },
  {
    path: '/patient-central/team-mode',
    name: 'patient-central.team-mode',
    component: () => import('@/views/CentralMonitoringTeam'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/patient-central/nursing-station/:viewId?',
    name: 'patient-central.nursing-station',
    component: () => import('@/views/patient/SafetyCenter'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/patient-central/:viewId?',
    name: 'patient-central',
    component: () => import('@/views/patient/SafetyCenter'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/form-builder',
    component: proxyComponent,
    children: [
      {
        path: '',
        name: 'form-builder',
        component: () => import('@/views/form_builder/Forms'),
        meta: {
          withoutDivision: true
        },
      },
      {
        path: 'add',
        name: 'form-builder.add',
        component: () => import('@/views/form_builder/AddForm.vue'),
        meta: {
          withoutDivision: true
        }
      },
      {
        path: ':id/edit',
        name: 'form-builder.edit',
        component: () => import('@/views/form_builder/AddForm.vue'),
        meta: {
          withoutDivision: true
        }
      },
    ]
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/profile/Profile'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/labeling',
    name: 'labeling.index',
    component: () => import('@/views/Labeling'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/delete-labeled-image',
    name: 'labeling.delete-image',
    component: () => import('@/views/DeleteLabeledImage.vue'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/reporting',
    component: proxyComponent,
    children: [
      {
        path: 'data-export',
        name: 'reporting.data-export',
        component: () => import('@/views/DataExport'),
        meta: {
          withoutDivision: true
        },
      },
      {
        path: 'shift-report',
        name: 'reporting.shift-report',
        component: () => import('@/views/ShiftReport'),
        meta: {
          withoutDivision: true
        }
      },
    ]
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/AllNotifications'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/live-video',
    name: 'live-video.external',
    component: () => import('@/views/LiveVideoExternal.vue'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/infinity-watch',
    name: 'infinity-watch',
    component: () => import('@/views/InfinityWatch'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/manager-view',
    name: 'manager-view',
    component: () => import('@/views/manager_view/ManagerView.vue'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/menu-management',
    name: 'menu-management',
    component: () => import('@/views/MenuManagement'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/operational-live-view',
    name: 'operational-live-view',
    component: () => import('@/views/OperationalLiveView'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/patient-tracker',
    name: 'patient-tracker',
    component: () => import('@/views/PatientTracker'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/time-machine',
    name: 'timeline',
    component: () => import('@/views/TimeMachine'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/digital-whiteboard/room/:roomId',
    name: 'digital-whiteboard.room',
    component: () => import('@/views/DigitalWhiteboard.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/digital-whiteboard/patient/:patientId',
    name: 'digital-whiteboard.patient',
    component: () => import('@/views/DigitalWhiteboard.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/family-note/:patientId',
    name: 'family-note',
    component: () => import('@/views/FamilyNotePublic.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank',
      unsecured: true
    }
  },
  {
    path: '/digital-sign/room/:roomId',
    name: 'digital-sign.room',
    component: () => import('@/views/DigitalSign.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/digital-sign/patient/:patientId',
    name: 'digital-sign.patient',
    component: () => import('@/views/DigitalSign.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/care-connect/:patientId',
    name: 'care-connect',
    component: () => import('@/views/CareConnect.vue'),
    meta: {
      withoutDivision: true,
      layout: 'public'
    }
  },
  {
    path: '/advanced-reporting/:dashboardId?',
    name: 'advanced-reporting',
    component: () => import('@/views/AdvancedReporting.vue'),
    meta: {
      withoutDivision: true,
    }
  },
  {
    path: '/aimee-demo',
    name: 'aimee-demo',
    component: () => import('@/views/AimeeDemo.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/recordings',
    name: 'recordings',
    component: () => import('@/views/Recordings.vue'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/virtual-request-types',
    name: 'virtual-request-types',
    component: () => import('@/views/VirtualRequestTypes'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/virtual-request-types/:id/edit',
    name: 'edit-virtual-request-type',
    component: () => import('@/views/EditVirtualRequestType'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/aimee-chat',
    name: 'aimee-chat',
    component: () => import('@/views/AimeeChat'),
    meta: {
      withoutDivision: true
    }
  },
  {
    path: '/aimee-room',
    name: 'aimee-room',
    component: () => import('@/views/AimeeTvDemo.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  },
  {
    path: '/aimee-room/screen',
    name: 'aimee-room-screen',
    component: () => import('@/views/AimeeTvDemoScreen.vue'),
    meta: {
      withoutDivision: true,
      layout: 'blank'
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  stringifyQuery(obj) {
    const str = qs.stringify(obj)
    return str ? `${str}` : ''
  },
  parseQuery(str) {
    return qs.parse(str)
  },
  scrollBehavior(to) {
    if (to.hash) {
      const hash = to.hash.substring(1).replace(/[^a-zA-Z0-9-_]/g, '');
      const element = document.getElementById(hash);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      const scrollableContainer = document.getElementById('layout__container-wrapper')
      if (scrollableContainer) {
        scrollableContainer.scrollTo({ top: 0 })
      }
    }
  }
})
router.beforeEach((to, from, next) => {
  to.meta.layout = to.meta.layout || 'default'
  next()
})
router.beforeEach(Auth0Guard)
router.beforeEach((to, from, next) => {
  if (from.path == '/' && from.name === undefined && to.path) {
    store.commit('setUrlAccessedDirectly', true)
  } else if (from.name && to.name) {
    store.commit('setUrlAccessedDirectly', false)
  }
  if (to.meta.unsecured) {
    next()
  } else {
    // two paths must be different to avoid reseting division picker state
    // when URL changes because of table filters, pager, etc
    if (from.path != to.path) {
      store.commit('setDivisionPickerState', to.meta.withoutDivision ? 'hidden' : 'visible')
    }
    const storeDivisionId = store.state.divisionId
    const isHomepageAfterAuth = to.query.code && to.query.state && to.path == '/'
    if (to.meta.withoutDivision || isHomepageAfterAuth) {
      next()
    } else {
      if (to.query.division_id) {
        next()
      } else {
        const route = { ...to }
        let divisionId = storeDivisionId
        if (divisionId == '*' && to.meta.allDivisionsEnabled === false) {
          divisionId = getAvailableDivisionId({ userObject: store.state.currentUser })
        }
        route.query.division_id = divisionId
        route.replace = false
        route.force = true
        next(route)
      }
    }
  }
})

export default router
